import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { OktaAuth } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import { Toaster } from "react-hot-toast"
import { oktaConfig } from './Config/OktaConfig'

import Header from './Components/Header'
import Footer from './Components/Footer'
import WorkbenchPage from './Pages/WorkbenchPage'
import PageNotFound from './Pages/PageNotFound'
import ProtectedRoute from './Components/ProtectedRoute'
import { UserProvider } from './Context/UserContext'
import MuleSoftPage from './Pages/MuleSoftPage'
import  NoAccessPage from './Pages/NoAccessPage'
import CustomLoginCallback from './Pages/CustomLoginPage'
const oktaAuth = new OktaAuth(oktaConfig)

export default function App () {
  return (
    <Router>
      <Security
        oktaAuth={oktaAuth}
        restoreOriginalUri={async (_oktaAuth, originalUri) => {
          window.location.replace(originalUri || '/')
        }}
      >
        <UserProvider>
          <Toaster position="top-right" reverseOrder={false} />
          <Header />
          <div className='bg-gray-50 min-h-screen flex flex-col'>
            <Routes>
              <Route path='/login/callback' element={<CustomLoginCallback />} />
              <Route path='/no-access' element={<NoAccessPage />} />
              <Route
                path='/'
                element={
                  <ProtectedRoute>
                    <WorkbenchPage />
                  </ProtectedRoute>
                }
              />
               <Route
                path='/ai-assistant'
                element={
                  <ProtectedRoute>
                    <MuleSoftPage />
                  </ProtectedRoute>
                }
              />
              <Route path='*' element={<PageNotFound />} />
            </Routes>
          </div>
          <Footer />
        </UserProvider>
      </Security>
    </Router>
  )
}
